import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@Component({
  standalone: true,
  selector: 'app-intensity-rating-demo',
  imports: [CommonModule, NgxSliderModule],
  templateUrl: './intensity-rating-demo.component.html',
  styleUrl: './intensity-rating-demo.component.scss',
})
export class IntensityRatingDemoComponent {
  @Input() isVisible = false;
  @Output() goNext = new EventEmitter<void>();

  // Demo slider configuration - same as intensity-rating but non-interactable and unselected
  value: number = 5; // Default middle value but will appear unselected due to transparent pointer
  options: Options = {
    showTicksValues: true,
    stepsArray: [
      { value: 1 },
      { value: 2 },
      { value: 3 },
      { value: 4 },
      { value: 5 },
      { value: 6 },
      { value: 7 },
      { value: 8 },
      { value: 9 },
    ],
    getPointerColor: () => 'transparent', // Make pointer transparent to appear unselected
    readOnly: true, // Keep as read-only for non-interactive behavior
  };

  onClick() {
    this.goNext.emit();
  }
} 